import { createContext } from 'react';
import type { Locale } from '../../utils/intl/locale';

export type { Locale };

export interface GlobalContextValue {
  locale: Locale;
}

const GlobalContext = createContext<GlobalContextValue>({
  locale: 'de',
});

export default GlobalContext;
